export default "/images/e093d43afdb5c257ecc76f6ac88bb1e7.avif";